import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import Paper from "@mui/material/Paper";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Chip as MuiChip } from "@mui/material";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import RocketIcon from "@mui/icons-material/Rocket";
import imageIndex from "../ImageIndex";
import { CourseCatalog } from "./WorkshopsSection";
import AutoAwesomeRoundedIcon from "@mui/icons-material/AutoAwesomeRounded";
import RocketLaunchRoundedIcon from "@mui/icons-material/RocketLaunchRounded";
import ScienceRoundedIcon from "@mui/icons-material/ScienceRounded";
import FacebookIcon from "@mui/icons-material/Facebook";

const presenciaImpactoImages = [
  imageIndex.PresenciaImpacto1,
  imageIndex.PresenciaImpacto2,
  imageIndex.PresenciaImpacto3,
];

const HydroRocketCarousel = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6000,
    arrows: true,
    adaptiveHeight: false,
  };

  const hydroRocketImages = [
    imageIndex.HidroCarousel1,
    imageIndex.HidroCarousel3,

    imageIndex.HidroCarousel5,
  ];

  return (
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
        "& .slick-slider": {
          height: { xs: 300, sm: 400, md: 700 },
        },
        "& .slick-track, & .slick-slide, & .slick-slide > div": {
          height: { xs: 300, sm: 400, md: 700 },
        },
        "& .slick-prev:before, & .slick-next:before": {
          color: "#d4af37",
        },
      }}
    >
      <Slider {...settings}>
        {hydroRocketImages.map((image, index) => (
          <Box
            key={index}
            sx={{
              position: "relative",
              height: { xs: 300, sm: 400, md: 700 },
              overflow: "hidden",
            }}
          >
            <Box
              component="img"
              src={image}
              alt={`Hidrocohete ${index + 1}`}
              sx={{
                width: "100%", // Adjust width as needed
                height: { xs: 300, sm: 400, md: 700 },
                objectFit: { xs: "cover", sm: "cover", md: "cover" },
                objectPosition: { xs: "middle", md: "center 60%" }, // Adjust vertical position on desktop
                position: "relative",
              }}
            />
          </Box>
        ))}
      </Slider>
    </Box>
  );
};

const PresenciaImpactoCarousel = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    adaptiveHeight: true,
  };

  return (
    <Box
      sx={{
        width: { xs: "100%", md: "50%" },
        maxWidth: "500px",
        height: { xs: 300, md: 380 },
        borderRadius: 2,
        overflow: "hidden",
        boxShadow: 3,
      }}
    >
      <Slider {...settings}>
        {presenciaImpactoImages.map((image, index) => (
          <Box key={index} sx={{ height: { xs: 300, md: 380 } }}>
            <Box
              component="img"
              src={image}
              alt={`Slide ${index + 1}`}
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </Box>
        ))}
      </Slider>
    </Box>
  );
};

const items = [
  {
    icon: <RocketIcon />,
    title:
      "CURSO ESPECIALIZANTE: PROPULSIÓN, METODOLOGÍA, CARACTERIZADO Y DISEÑO DE TOBERAS DE MOTOR",
    date: "Inicia 23 de Agosto",
    images: [`url(${imageIndex.Curso202510})`],
    url: "https://bit.ly/AcademiaENMICE",
  },
  {
    icon: <RocketIcon />,
    title:
      "CURSO MODULAR PROFESIONAL CANSAT: CONSTRUCCIÓN, PROGRAMACIÓN Y LANZAMIENTO",
    date: "Inicia 18 de Agosto",
    images: [
      `url(${imageIndex.Curso202508})`,
      `url(${imageIndex.Curso202509})`,
    ],
    url: "https://bit.ly/AcademiaENMICE",
  },
  {
    icon: <RocketIcon />,
    title: "CURSOS AEROESPACIALES Y ESPACIALES.",
    images: [`url(${imageIndex.Curso202502})`],
    url: "https://bit.ly/AcademiaENMICE",
  },
  {
    icon: <RocketIcon />,
    title: "CURSOS AEROESPACIALES Y ESPACIALES.",
    images: [`url(${imageIndex.Curso202503})`],
    url: "https://bit.ly/AcademiaENMICE",
  },
];

const Chip = styled(MuiChip)(({ theme }) => ({
  variants: [
    {
      props: ({ selected }) => selected,
      style: {
        background:
          "linear-gradient(to bottom right, hsl(210, 98%, 48%), hsl(210, 98%, 35%))",
        color: "hsl(0, 0%, 100%)",
        borderColor: theme.palette.primary.light,
        "& .MuiChip-label": {
          color: "hsl(0, 0%, 100%)",
        },
        ...theme.applyStyles("dark", {
          borderColor: theme.palette.primary.dark,
        }),
      },
    },
  ],
}));

export default function AcademiaFeatures() {
  const [selectedItemIndex, setSelectedItemIndex] = React.useState(0);
  const [imageIndices, setImageIndices] = React.useState(items.map(() => 0));

  // Rotate through items
  React.useEffect(() => {
    const interval = setInterval(() => {
      setSelectedItemIndex((prevIndex) => (prevIndex + 1) % items.length);
    }, 6000); // Change item every 6 seconds

    return () => clearInterval(interval);
  }, []);

  // Rotate through images for the currently selected item
  React.useEffect(() => {
    const imageInterval = setInterval(() => {
      setImageIndices((prev) => {
        const newIndices = [...prev];
        const currentItem = items[selectedItemIndex];
        newIndices[selectedItemIndex] =
          (prev[selectedItemIndex] + 1) % currentItem.images.length;
        return newIndices;
      });
    }, 3000); // Change image every 3 seconds

    return () => clearInterval(imageInterval);
  }, [selectedItemIndex]);

  const handleItemClick = (index) => {
    setSelectedItemIndex(index);
  };

  const selectedFeature = items[selectedItemIndex];
  const currentImageIndex = imageIndices[selectedItemIndex];
  const currentImage = selectedFeature.images[currentImageIndex];

  return (
    <>
      <Container id="features" sx={{ py: { xs: 8, sm: 16 } }}>
        <Grid container spacing={6}>
          <Grid item xs={12} md={6}>
            <div>
              <Typography
                component="h2"
                variant="h2"
                sx={{ color: "primary.main" }}
              >
                Oferta disponible
              </Typography>
              <Typography
                variant="body1"
                sx={{ color: "text.secondary", mb: { xs: 2, sm: 4 } }}
              >
                Cursos, talleres y capacitaciones virtuales y presenciales. Para
                grupos no especializados y especializados.
              </Typography>
            </div>

            {/* Mobile chips navigation */}
            <Grid
              container
              item
              sx={{ gap: 1, display: { xs: "auto", sm: "none" } }}
            >
              {items.map(({ title }, index) => (
                <Chip
                  key={index}
                  label={title}
                  onClick={() => handleItemClick(index)}
                  selected={selectedItemIndex === index}
                />
              ))}
            </Grid>

            {/* Mobile card view */}
            <Card
              variant="outlined"
              sx={{ display: { xs: "auto", sm: "none" }, mt: 4 }}
            >
              <Box
                sx={{
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  minHeight: 280,
                  backgroundImage: currentImage,
                }}
              />
              <Box sx={{ px: 2, pb: 2 }}>
                <Typography
                  gutterBottom
                  sx={{ color: "text.primary", fontWeight: "medium" }}
                >
                  {selectedFeature.title}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: "text.secondary", mb: 1.5 }}
                >
                  {selectedFeature.description}
                </Typography>
                <Link
                  href={selectedFeature.url}
                  target="_blank"
                  color="primary"
                  variant="body2"
                  sx={{
                    fontWeight: "bold",
                    display: "inline-flex",
                    alignItems: "center",
                    "& > svg": { transition: "0.2s" },
                    "&:hover > svg": { transform: "translateX(2px)" },
                  }}
                >
                  <span>Registrarme</span>
                  <ChevronRightRoundedIcon
                    fontSize="small"
                    sx={{ mt: "1px", ml: "2px" }}
                  />
                </Link>
              </Box>
            </Card>

            {/* Desktop list view */}
            <Stack
              direction="column"
              spacing={2}
              useFlexGap
              sx={{
                justifyContent: "center",
                alignItems: "flex-start",
                width: "100%",
                display: { xs: "none", sm: "flex" },
                mb: 6, // Added margin bottom to separate from CourseCatalog
              }}
            >
              {items.map(({ icon, title, description, date }, index) => (
                <Card
                  key={index}
                  component={Button}
                  onClick={() => handleItemClick(index)}
                  sx={[
                    (theme) => ({
                      p: 3,
                      height: "fit-content",
                      width: "100%",
                      background: "none",
                      "&:hover": {
                        background:
                          "linear-gradient(to bottom right, hsla(210, 100%, 97%, 0.5) 25%, hsla(210, 100%, 90%, 0.3) 100%)",
                        borderColor: "primary.light",
                        boxShadow: "0px 2px 8px hsla(0, 0%, 0%, 0.1)",
                        ...theme.applyStyles("dark", {
                          background:
                            "linear-gradient(to right bottom, hsla(210, 100%, 12%, 0.2) 25%, hsla(210, 100%, 16%, 0.2) 100%)",
                          borderColor: "primary.dark",
                          boxShadow: "0px 1px 8px hsla(210, 100%, 25%, 0.5) ",
                        }),
                      },
                    }),
                    selectedItemIndex === index &&
                      ((theme) => ({
                        backgroundColor: "action.selected",
                        borderColor: "primary.light",
                        ...theme.applyStyles("dark", {
                          borderColor: "primary.dark",
                        }),
                      })),
                  ]}
                >
                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      textAlign: "left",
                      flexDirection: { xs: "column", md: "row" },
                      alignItems: { md: "center" },
                      gap: 2.5,
                    }}
                  >
                    <Box
                      sx={[
                        (theme) => ({
                          color: "grey.400",
                          ...theme.applyStyles("dark", {
                            color: "grey.600",
                          }),
                        }),
                        selectedItemIndex === index && {
                          color: "primary.main",
                        },
                      ]}
                    >
                      {icon}
                    </Box>
                    <div>
                      <Typography
                        gutterBottom
                        sx={{ color: "text.primary", fontWeight: "bold" }}
                      >
                        {title}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ color: "text.secondary", mb: 1.5 }}
                      >
                        {description}
                      </Typography>
                      {date && (
                        <Typography
                          variant="body2"
                          sx={{
                            color: "text.primary",
                            mb: 1.5,
                            fontWeight: "bold",
                          }}
                        >
                          {date}
                        </Typography>
                      )}
                      <Link
                        href={selectedFeature.url}
                        target="_blank"
                        color="primary"
                        variant="body2"
                        onClick={(event) => {
                          event.stopPropagation();
                        }}
                        sx={{
                          fontWeight: "bold",
                          display: "inline-flex",
                          alignItems: "center",
                          "& > svg": { transition: "0.2s" },
                          "&:hover > svg": { transform: "translateX(2px)" },
                        }}
                      >
                        <span>Registrarme</span>
                        <ChevronRightRoundedIcon
                          fontSize="small"
                          sx={{ mt: "1px", ml: "2px" }}
                        />
                      </Link>
                    </div>
                  </Box>
                </Card>
              ))}
            </Stack>
          </Grid>

          {/* Right side image panel */}
          <Grid
            item
            xs={12}
            md={6}
            sx={{ display: { xs: "none", sm: "flex" }, width: "100%" }}
          >
            <Card
              variant="outlined"
              sx={{
                height: "100%",
                width: "100%",
                display: { xs: "none", sm: "flex" },
                pointerEvents: "none",
              }}
            >
              <Box
                sx={{
                  m: "auto",
                  width: "100%",
                  height: "100%",
                  backgroundSize: "contain",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  overflow: "hidden",
                  backgroundImage: currentImage,
                }}
              />
            </Card>
          </Grid>
        </Grid>
      </Container>

      {/* CourseCatalog section below */}
      <Box>
        <Container maxWidth="lg">
          <CourseCatalog />
        </Container>
      </Box>

      {/* Hidrocohetes section*/}
      <Box
        component="section"
        sx={{
          backgroundColor: "#0a192f", // workshop-navy
          color: "white",
          py: 8,
          px: 3,
        }}
      >
        <Container maxWidth="md">
          {/* Header */}
          <Box sx={{ textAlign: "center", mb: 4 }}>
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: "medium",
                mb: 2,
                color: "white",
              }}
            >
              Agenda con nosotros tu
            </Typography>
            <Typography
              variant="h1"
              sx={{
                fontWeight: "bold",
                mb: 4,
                color: "#d4af37", // workshop-gold
                fontSize: {
                  xs: "2rem",
                  sm: "4rem",
                  md: "5rem",
                },
                lineHeight: 1.1,
              }}
            >
              TALLER DE
              <br />
              HIDROCOHETES
            </Typography>
          </Box>

          {/* Question pill */}
          <Box sx={{ display: "flex", justifyContent: "center", mb: 6 }}>
            <Paper
              elevation={0}
              sx={{
                backgroundColor: "white",
                color: "#0a192f", // workshop-navy
                px: 4,
                py: 2,
                borderRadius: "9999px",
                fontWeight: "medium",
                fontSize: "0.875rem",
                maxWidth: "sm",
                textAlign: "center",
              }}
            >
              ¿Buscas una actividad dinámica, divertida y espacial para tu
              escuela o comunidad?
            </Paper>
          </Box>

          {/* Description */}
          <Box sx={{ textAlign: "center", mb: 6, maxWidth: "md", mx: "auto" }}>
            <Typography
              variant="body1"
              sx={{
                lineHeight: 1.75,
                color: "white",
              }}
            >
              Academia ENMICE ofrece su Taller insignia de Hidrocohetes diseñado
              para instituciones educativas, agrupaciones civiles, eventos
              académicos, foros de divulgación científica organizados por
              entidades gubernamentales o el sector privado e Institutos de la
              Juventud municipales y estatales, ideales para:
            </Typography>
          </Box>

          {/* Features */}
          <Grid container spacing={4} sx={{ mb: 4 }}>
            <Grid item xs={12} md={4}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <AutoAwesomeRoundedIcon
                  sx={{ color: "#d4af37", fontSize: "2rem" }}
                />
                <Typography
                  variant="h6"
                  sx={{
                    color: "#d4af37",
                    fontWeight: "semibold",
                  }}
                >
                  Estímulo Científico
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <RocketLaunchRoundedIcon
                  sx={{ color: "#d4af37", fontSize: "2rem" }}
                />
                <Typography
                  variant="h6"
                  sx={{
                    color: "#d4af37",
                    fontWeight: "semibold",
                  }}
                >
                  Formación Aeroespacial
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <ScienceRoundedIcon
                  sx={{ color: "#d4af37", fontSize: "2rem" }}
                />
                <Typography
                  variant="h6"
                  sx={{
                    color: "#d4af37",
                    fontWeight: "semibold",
                  }}
                >
                  Vocación STEAM
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Hidrocohetes carousel */}
      <Box
        component="section"
        sx={{
          backgroundColor: "#0a192f", // workshop-navy
          color: "white",
        }}
      >
        <HydroRocketCarousel />
      </Box>

      {/* Celestron Section */}
      <Box
        sx={{
          width: "100%",
          backgroundImage:
            "radial-gradient(ellipse 80% 50% at 50% 50%, hsl(210, 100%, 90%), transparent)",
        }}
      >
        <Container
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            pt: { xs: 15, sm: 15 },
            pb: { xs: 5, sm: 5 },
          }}
        >
          <Stack
            spacing={2}
            useFlexGap
            sx={{ alignItems: "center", width: { xs: "100%", sm: "70%" } }}
          ></Stack>
          <Box sx={{ textAlign: { xs: "center", sm: "center" } }}>
            <Typography
              variant="h1"
              sx={{
                fontSize: "clamp(2rem, 10vw, 2.5rem)",
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                alignItems: { xs: "center", sm: "baseline" },
                lineHeight: 1.2,
              }}
            >
              Agenda con nosotros tu
            </Typography>
          </Box>
          <Box sx={{ textAlign: { xs: "center", sm: "center" } }}>
            <Typography
              variant="h1"
              sx={{
                mt: 5,
                color: "primary.main",
                fontSize: "clamp(3rem, 10vw, 3.5rem)",
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                alignItems: { xs: "center", sm: "baseline" },
                lineHeight: 1.2,
              }}
            >
              Observación Astronómica
            </Typography>
          </Box>
          <Box
            sx={{
              textAlign: "center",
              mt: 4,
              mb: 6,
              maxWidth: "md",
              mx: "auto",
            }}
          >
            <Typography
              variant="h5"
              sx={{
                textAlign: "center",
                color: "text.secondary",
                fontSize: "clamp(1rem, 5vw, 1.1rem)",
              }}
            >
              Academia ENMICE ofrece Observaciones Astronómicas para
              instituciones, asociaciones civiles, eventos académicos,
              científicos o tecnológicos, foros organizados por gobierno o
              sector público y actividades de divulgación científica
            </Typography>

            <Typography
              variant="h5"
              sx={{
                mt: 5,
                textAlign: "center",
                fontSize: "clamp(1rem, 5vw, 1.1rem)",
              }}
            >
              Trabajamos con el líder mundial de telescopía
            </Typography>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
                maxWidth: "400px",
                margin: "0 auto", // Center horizontally
                mt: 2,
                height: "auto",
              }}
            >
              <Box
                component="img"
                src={imageIndex.CelestronLogoNegro}
                alt="Logo de Celestron"
                sx={{
                  width: "100%",
                  height: "auto",
                  objectFit: "contain",
                }}
              />
            </Box>
          </Box>

          <Typography
            variant="h5"
            sx={{
              color: "text.secondary",
              textAlign: "center",
              fontSize: "clamp(1rem, 5vw, 1.1rem)",
            }}
          >
            Conoce nuestros telescopios
          </Typography>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              width: "100%",
              maxWidth: "800px",
              margin: "0 auto", // Center horizontally
              mt: 2,
              height: "auto",
              border: "3px solid #1c6cadff", // Gold border
              borderRadius: "8px",
            }}
          >
            <Box
              component="img"
              src={imageIndex.TelescopiosAcademia}
              alt="Logo de Celestron"
              sx={{
                width: "100%",
                height: "auto",
                objectFit: "contain",
              }}
            />
          </Box>
        </Container>
      </Box>

      {/* Estes Section */}
      <Container
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" }, // Column on mobile, row on larger screens
          alignItems: "center",
          pt: { xs: 15, sm: 15 },
          pb: { xs: 5, sm: 5 },
          gap: 8, // Adds spacing between image and text
        }}
      >
        <Stack spacing={2} useFlexGap sx={{ width: { xs: "100%", sm: "60%" } }}>
          <Typography
            variant="h1"
            sx={(theme) => ({
              fontSize: "clamp(2rem, 10vw, 2.5rem)",
              color: "primary.main",
              textAlign: { xs: "center", sm: "left" },
              ...theme.applyStyles("dark", {
                color: "primary.light",
              }),
            })}
          >
            Distribudores autorizados de{" "}
            <Box
              component="span"
              sx={{
                display: { xs: "block", sm: "block" }, // Block (new line) on mobile, inline on larger screens
                textAlign: { xs: "center", sm: "left" }, // Ensure the span is also centered on mobile
              }}
            >
              Estes Rockets en México
            </Box>
          </Typography>

          <Typography
            variant="h5"
            sx={{
              textAlign: { xs: "center", sm: "left" }, // Center on mobile, left on larger screens
              color: "text.secondary",
              fontSize: "clamp(1rem, 5vw, 1.1rem)",
              "& span": {
                fontWeight: "bold",
                color: "text.primary",
              },
            }}
          >
            En Academia ENMICE promovemos el acceso seguro y educativo a la
            cohetería experimental a través de productos originales de{" "}
            <span>ESTES Rockets</span>, la marca líder mundial en modelado de
            cohetes. <span>Ofrecemos kits, motores y accesorios</span> ideales
            para actividades educativas, científicos y formación técnica para
            pequeños y grandes..
          </Typography>

          <Typography
            variant="h5"
            sx={{
              textAlign: { xs: "center", sm: "left" }, // Center on mobile, left on larger screens
              color: "text.secondary",
              fontSize: "clamp(1rem, 5vw, 1.1rem)",
              "& span": {
                fontWeight: "bold",
                color: "text.primary",
              },
            }}
          >
            <span>
              ¿Buscas kits, motores o lanzadores?
              <br /> ¿Necesitas acondicionar un laboratorio de
              <br /> tu institución académica con un contenido innovador e
              increíble?
              <br /> Pregunta por el catálogo y cotiza con nosotros tu proyecto.
            </span>
          </Typography>
        </Stack>

        {/* Image on the right */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 4,
            width: { xs: "100%", sm: "40%" },
          }}
        >
          <Box
            component="img"
            src={imageIndex.EstesLogoColor}
            alt="Academia ENMICE"
            sx={{
              width: { xs: "60%", sm: "70%", md: "70%" }, // Responsive width
              height: "auto",
              maxWidth: "100%",
            }}
          />
          <Box
            component="img"
            src={imageIndex.EstesIlustracion}
            alt="Academia ENMICE"
            sx={{
              width: { xs: "60%", sm: "50%", md: "50%" }, // Responsive width
              height: "auto",
              maxWidth: "100%",
              borderRadius: "8px",
            }}
          />
        </Box>
      </Container>

      {/* Presencia E Impacto */}
      <Container
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: "center",
          py: { xs: 4, md: 8 },
          gap: { xs: 4, md: 8 },
        }}
      >
        {/* Carousel */}
        <PresenciaImpactoCarousel />

        {/* Text */}
        <Box
          sx={{
            width: { xs: "100%", md: "50%" },
            display: "flex",
            flexDirection: "column",
            gap: 3,
          }}
        >
          <Typography
            variant="h1"
            sx={(theme) => ({
              fontSize: "clamp(2rem, 10vw, 2.5rem)",
              color: "primary.main",
              textAlign: { xs: "center", sm: "center" },
              ...theme.applyStyles("dark", {
                color: "primary.light",
              }),
            })}
          >
            Presencia e impacto
          </Typography>
          <Typography
            variant="h5"
            sx={{
              textAlign: { xs: "center", sm: "center" }, // Center on mobile, left on larger screens
              color: "text.secondary",
              fontSize: "clamp(1rem, 5vw, 1.1rem)",
            }}
          >
            En Academia ENMICE colaboramos activamente con centros de la
            juventud del Área Metropolitana de Guadalajara y con el Gobierno de
            Zapopan, acercando la ciencia y la tecnología a espacios
            comunitarios.
          </Typography>

          <Typography
            variant="h5"
            sx={{
              textAlign: { xs: "center", sm: "center" }, // Center on mobile, left on larger screens
              color: "text.secondary",
              fontSize: "clamp(1rem, 5vw, 1.1rem)",
              "& span": {
                fontWeight: "bold",
                color: "primary.main",
              },
            }}
          >
            Hemos participado en el{" "}
            <span>Encuentro Nacional de Divulgación Científica </span>
            de la Sociedad Mexicana de Física en Chihuahua y este año fuimos
            aceptados nuevamente para participar en Toluca.
          </Typography>

          <Typography
            variant="h5"
            sx={{
              textAlign: { xs: "center", sm: "center" }, // Center on mobile, left on larger screens
              color: "text.secondary",
              fontSize: "clamp(1rem, 5vw, 1.1rem)",
              "& span": {
                fontWeight: "bold",
                color: "#f6693a",
              },
            }}
          >
            Además, somos parte de las{" "}
            <span>Jornadas Nacionales de Física</span>, reafirmando nuestro
            compromiso con la divulgación y la científica en México.
            <br /> <br />
            LINK de las jornadas
            <br />
            <Link
              href="https://www.facebook.com/share/p/16twVSDp74/"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                display: "inline-flex",
                alignItems: "center",
                mt: 1,
                color: "#1877F2",
                textDecoration: "none",
                "&:hover": {
                  textDecoration: "underline",
                },
              }}
            >
              <FacebookIcon sx={{ mr: 1 }} />
              Ver en Facebook
            </Link>
          </Typography>
        </Box>
      </Container>
    </>
  );
}
